import { useState, useRef } from "react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { Volume2, VolumeX } from "lucide-react";

const VIDEO_URL = "/hero-video.mp4";

export const HeroSection = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !muted;
      setMuted(!muted);
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center" data-testid="hero-section">
      {/* Video background */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src={VIDEO_URL}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        data-testid="hero-video"
      />
      <div className="absolute inset-0 bg-[#191646]/50" />

      {/* Mute toggle */}
      <button
        onClick={toggleMute}
        data-testid="hero-mute-toggle"
        className="absolute bottom-24 right-6 md:right-12 z-20 w-10 h-10 bg-white/10 backdrop-blur-sm border border-white/20 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        {muted ? <VolumeX className="text-white" size={18} /> : <Volume2 className="text-white" size={18} />}
      </button>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <p className="text-[#C9A85A] text-sm md:text-base tracking-[0.3em] mb-6 uppercase font-body font-medium" data-testid="hero-overline">
          A Place for Stories
        </p>

        <h1 className="font-heading text-6xl md:text-8xl lg:text-9xl text-white font-medium tracking-tight mb-4" data-testid="hero-title">
          KIPLINGS
        </h1>

        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-12 h-[1px] bg-[#C9A85A]" />
          <p className="font-subheading text-xl md:text-2xl text-[#C9A85A] italic">D&eacute;li & Bistro</p>
          <div className="w-12 h-[1px] bg-[#C9A85A]" />
        </div>

        <p className="text-white/70 text-base md:text-lg max-w-xl mx-auto mb-10 font-body font-light leading-relaxed">
          Food and Time Well Spent
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button data-testid="hero-menu-btn" className="bg-[#C9A85A] text-[#191646] hover:bg-transparent hover:text-[#C9A85A] border border-[#C9A85A] rounded-none px-10 py-6 text-sm font-body font-semibold tracking-[0.15em] uppercase transition-all duration-300" onClick={() => navigate("/menu")}>
            Explore Menu
          </Button>
          <Button data-testid="hero-reserve-btn" variant="outline" className="bg-transparent text-white border border-white/60 hover:bg-white hover:text-[#191646] rounded-none px-10 py-6 text-sm font-body font-semibold tracking-[0.15em] uppercase transition-all duration-300" onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}>
            Reserve a Table
          </Button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="text-white/40 text-xs tracking-[0.2em] uppercase font-body">Scroll</span>
        <div className="w-[1px] h-8 bg-white/30" />
      </div>
    </section>
  );
};
